import Button from 'components/Button'
import {
  FooterFlex,
  FormItem,
  FormWrapper,
  Heading,
  StyledDrawer,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import React, { useEffect, useState } from 'react'

import { Form } from 'antd'
import Control from 'components/Control/Control'
import RichEditor from 'components/RichEditor/index'
import { setResumeData } from 'modules/Onboarding/actions'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'

const ObjectiveDrawer = ({
  drawerStatus,
  setdrawerStatus,
  studentFormData,
  updateStudentData,
}) => {
  const [form] = Form.useForm()
  const dispatch = new useDispatch()
  const [objective, setObjective] = useState(studentFormData?.resume?.objective)

  const onChangeCareerObject = value => {
    form.setFieldsValue({
      objective: value,
    })
    setObjective(value)
  }

  useEffect(() => {
    form.setFieldsValue({
      objective: studentFormData?.resume?.objective,
    })
  })

  const countRichTextCharacters = richText => {
    // Remove HTML tags using a regular expression
    const plainText = richText?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')

    // Count the characters in the plain text
    const characterCount = plainText?.length || 0 // Set to 0 if undefined

    return characterCount
  }

  const submitHandler = async values => {
    let payload = {
      admin: {
        ...studentFormData?.admin,
        countryCode: studentFormData?.admin?.countryCode,
      },
      student: studentFormData?.student,
      degreeStreamMap: !studentFormData?.student?.isExpCandidate
        ? {
            degreeId: studentFormData?.currentCourse?.degreeId,
            streamId: studentFormData?.currentCourse?.streamId,
          }
        : {},
      studentPersonalProfile: studentFormData?.studentPersonalProfile,
      currentCourse: !studentFormData?.student?.isExpCandidate
        ? {
            ...studentFormData?.currentCourse,
            marks: studentFormData?.currentCourse?.marks ?? 0,
          }
        : {},
      education: studentFormData?.education || [],
      resume: { ...studentFormData?.resume, objective: values.objective },
    }
    if (payload?.currentCourse?.specialisationId === null) {
      delete payload?.currentCourse?.specialisationId
    }
    if (payload?.studentPersonalProfile?.secondaryEmail === null) {
      delete payload?.studentPersonalProfile?.secondaryEmail
    }
    if (payload?.studentPersonalProfile?.registraionNo) {
      delete payload?.studentPersonalProfile?.registraionNo
    }
    studentFormData?.education.map((item, index) => {
      if (item?.skills === null) delete payload?.education[index]?.skills
      if (item?.degreeStreamMapId === null)
        delete payload?.education[index]?.degreeStreamMapId
    })
    if (payload?.currentCourse?.degreeStreamMapId === null) {
      delete payload?.currentCourse?.degreeStreamMapId
    }
    let response = await updateStudentData(payload)
    dispatch(setResumeData(payload))
    if (response?.success === true) {
      SuccessMessage('Personal info saved successfully!')
      setdrawerStatus(false)
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const content = () => {
    return (
      <FormWrapper
        form={form}
        onFinish={submitHandler}
        scrollToFirstError
        id={'objectiveForm'}
        layout="vertical"
      >
        <Control top="10px">
          <Heading>Objective</Heading>
        </Control>
        <Control>
          <FormItem
            name={'objective'}
            rules={[
              {
                validator: async (_, value) => {
                  if (countRichTextCharacters(objective) > 1000) {
                    return Promise.reject(
                      new Error('Maximum 1000 Character allowed!')
                    )
                  }

                  return Promise.resolve()
                },
              },
              {
                validator: async (_, value) => {
                  const plainText = value
                    .replace(/<[^>]*>/g, '')
                    .replace(/&nbsp;/g, ' ')

                  if (/\s/.test(!plainText) || plainText.trim().length === 0) {
                    return Promise.reject(
                      new Error('Description cannot contain spaces')
                    )
                  }

                  return Promise.resolve() // Validation passed
                },
              },
            ]}
          >
            <RichEditor value={objective} onChange={onChangeCareerObject} />
            {'Characters: ' + countRichTextCharacters(objective) + ' / 1000'}
          </FormItem>
        </Control>
      </FormWrapper>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          form={'objectiveForm'}
          htmlType="submit"
          text={'Update'}
          disabled={!form.isFieldTouched('objective')}
        />
      </FooterFlex>
    )
  }
  return (
    <StyledDrawer
      width="675px"
      title={'Objective'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
  )
}

export default ObjectiveDrawer
